<template>
  <div class="dr-t__row">
    <div class="dr-t__cell">
      <div class="dr-t__head_responsive bg-gray__extralight">
        <div class="dr-t__row">
          <div class="dr-t__cell">{{ localize.KZ_DELIVERY_TYPE }}</div>
        </div>
      </div>
      <div class="dr-t__cell_inner">
        <div class="d-flex align-items-start">
          <b class="mt-3">{{ methodTitle }}</b>
        </div>
      </div>
    </div>
    <div class="dr-t__cell">
      <div class="dr-t__head_responsive bg-gray__extralight">
        <div class="dr-t__row">
          <div class="dr-t__cell">{{ localize.KZ_DELIVERY_PERIOD }}</div>
        </div>
      </div>
      <div class="dr-t__cell_inner">
        <b>{{ deliveryPeriod }}</b>
      </div>
    </div>
    <div class="dr-t__cell">
      <div class="dr-t__head_responsive bg-gray__extralight">
        <div class="dr-t__row">
          <div class="dr-t__cell">{{ localize.KZ_DELIVERY_PRICE }}</div>
        </div>
      </div>
      <div class="dr-t__cell_inner" v-html="priceWithDiscount"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    methodTitle: String,
    price: String,
    periodFrom: Number,
    periodTo: Number,
    customPeriod: String,
  },
  computed: {
    localize() {
      return BX.Vue.getFilteredPhrases('KZ_DELIVERY_');
    },
    deliveryPeriod() {
        if (this.periodFrom) {
            if (this.periodFrom == this.periodTo) {
                return this.localize.KZ_DELIVERY_PERIOD_FROM_ONLY_TEMPLATE
                    .replace('#DAYS_FROM#', this.periodFrom)
            }

            return this.localize.KZ_DELIVERY_PERIOD_TEMPLATE
                .replace('#DAYS_FROM#', this.periodFrom)
                .replace('#DAYS_TO#', this.periodTo)
        } else {
            return this.customPeriod
        }
    },
    deliveryPrice() {
        return this.localize.KZ_DELIVERY_PRICE_TEMPLATE
            .replace('#PRICE#', this.price)
    },
    priceWithDiscount() {
        if (parseInt(this.price) == 0) {
            return BX.message('KZ_REMOTE_DELIVERY_PRICE_FREE_MESSAGE');
        } else {
            return BX.message('KZ_REMOTE_DELIVERY_PRICE_MESSAGE')
                .replace('#FORMATTED_PRICE#', this.deliveryPrice);
        }
    }
  }
}
</script>
